import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { getHealthEnquiryAPI } from '../../Redux/HealthRedux';
import moment from 'moment';
const { axiosPOSTCall1 } = require('../../utilities/utils/apiPost');

const primaryColor = 'rgb(242, 140, 40)';
const successBg = '#f7f9fc';

// ✅ Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
`;

const glowPulse = keyframes`
  0% { box-shadow: 0 0 0px ${primaryColor}; }
  50% { box-shadow: 0 0 20px ${primaryColor}; }
  100% { box-shadow: 0 0 0px ${primaryColor}; }
`;

const draw = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

// ✅ Styled Components
const PageWrapper = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${successBg};
`;

const Card = styled.div`
  background: white;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  text-align: center;
  animation: ${fadeIn} 0.6s ease-out;
  max-width: 420px;
  width: 100%;
`;

const CheckmarkContainer = styled.div`
  width: 90px;
  height: 90px;
  margin: 0 auto 25px;
  border-radius: 50%;
  background: ${primaryColor};
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${glowPulse} 2s infinite;
`;

const Svg = styled.svg`
  width: 50px;
  height: 50px;
  stroke: white;
  stroke-width: 6;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  animation: ${draw} 1.2s ease forwards;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
`;

const Title = styled.h2`
  color: #333;
  margin-bottom: 10px;
  font-size: 24px;
`;

const Message = styled.p`
  color: #666;
  font-size: 15px;
  margin-bottom: 32px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

const Button = styled.button`
  flex: 1;
  padding: 12px 18px;
  font-size: 15px;
  background: ${(props) =>
    props.variant === 'back' ? '#9e9e9e' : primaryColor};
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: ${(props) =>
      props.variant === 'back' ? '#7e7e7e' : 'rgb(230, 120, 20)'};
  }
`;

// ✅ Main Component
const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [enquiryId, setEnquiryId] = useState(null);

  const { isFetching, septateCombinedRedux, error, success } = useSelector(
    (state) => state.health
  );
  console.log(
    '🚀 ~ PaymentSuccessPage ~ septateCombinedRedux:',
    septateCombinedRedux
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('enquiryId');
    setEnquiryId(id);
  }, []);
  useEffect(() => {
    if (enquiryId) {
      dispatch(getHealthEnquiryAPI({ enquiryId }));
    }
  }, [enquiryId, dispatch]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        enquiryId,
        tid: septateCombinedRedux?.savePaymentRequest?.TransactionID,
      };

      await axiosPOSTCall1(
        '/healthInsurance/health/savePayment/health-fg',
        payload,
        (callback) => {
          console.log('🚀 ~ handleSubmit ~ callback:', callback);
          if (callback?.status === 'error') {
            alert(callback?.message || 'Error processing payment');
            return;
          }
        }
      );
    } catch (error) {
      console.log('🚀 ~ handleSubmit ~ error:', error);
      console.error('API error:', error);
    }
  };

  return (
    <PageWrapper>
      <Card>
        <CheckmarkContainer>
          <Svg viewBox="0 0 52 52">
            <path d="M14 27 L22 35 L38 17" />
          </Svg>
        </CheckmarkContainer>
        <Title>Payment Successful!</Title>
        <Message>Your transaction was completed successfully.</Message>
        <ButtonGroup>
          <Button variant="back" onClick={handleBack}>
            Back
          </Button>
          <Button onClick={handleSubmit}>Generate Policy</Button>
        </ButtonGroup>
      </Card>
    </PageWrapper>
  );
};

export default PaymentSuccessPage;
